import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ClaimsService } from '../services/claims.service';

@Injectable()
export class BillingGuard {

    constructor(
        private router: Router,
        private claimsService: ClaimsService
    ) { }

    canActivate() {
        const hasBillingRole = this.claimsService.hasBillingFeature() || this.claimsService.isSuperUser();
        if (!hasBillingRole) {
            this.router.navigate(['/auth/logout']);
        }
        return hasBillingRole;
    }
}
